export function headercolor() {
  $(window).on("scroll", function() {
    if ($(this).scrollTop() > 0) { // スクロールが始まったら
      $(".p-header").css("background", "rgba(255, 255, 255, 0.7)"); // 背景色を設定
    } else {
      $(".p-header").css("background", "transparent"); // 透明な背景色に設定
    }
  });
}